// MAGIC_DESPROCKET_START
//   ************THIS IS NOT THE RIGHT WAY TO STRUCTURE MODERN JS FILES************
//
//   For details and info on using this file see the wiki:
//     https://github.com/academia-edu/wiki/blob/master/development/formerly-sprockets-files.md
//
//   STATUS: auto generated
//   LOADERS:
//   ROOT: app/assets/javascripts/libraries_and_infrequently_changed.js
// MAGIC_DESPROCKET_END
/* A simple Base object for implementing prototypical object inheritance and initialization */
/* Don't use this -- just use CoffeeScript classes. */

c.Base = {

    //return a new object with this as it's prototype, with members extended /overriden by the defiition
    inherit: function(definition) {
        var obj = $x.extend($x.object(this), definition);
        return obj;
    },

    //returns a new object with this as it's protoype, and with init() having been called on that new object, passing in the args given here
    create: function() {
        var self = $x.object(this);
        self.init.apply(self, arguments);
        return self;
    },

    //just a stub - override in derived objects
    init: function() {
        return this;
    }

};
